// src/lib/admin.js
// Emails that receive admin privileges (case-insensitive).
export const ADMIN_EMAILS = [
  'vlad@manacommon.com',
  'etienne@manatech.com',
  'sergio@manatech.com',
  'charly@manatech.com',
];

export function isAdminEmail(email) {
  if (!email) return false;
  const normalized = email.trim().toLowerCase();
  return ADMIN_EMAILS.some(e => e.trim().toLowerCase() === normalized);
}
